export default "__VITE_ASSET__CCAiwGEU__"